var b = 1024;
export var toMegabytes = function (bytes) {
    return bytes / Math.pow(b, 2);
};
